import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: true,
  selector: 'ui-wrapper',
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.Eager,
  // obsahový kontejner stránky: celá šířka okna, boční okraje podle gov.cz; max šířku na střed dává --app-content-max-width
  host: {
    class: 'box-border w-full max-w-[var(--app-content-max-width,none)] mx-auto px-4 md:px-8 lg:px-10',
  },
})
export class WrapperComponent {}
